angular.module('aprima-core-ui').directive('apAddress',
    ['Bridge',
        function (Bridge) {
            'use strict';

            return {
                restrict: 'E',
                scope: {
                    address: '='
                },
                templateUrl: '/core-ui/views/directives/apAddress.html',
                link: function($scope) {
                    $scope.openMap = function () {
                        Bridge.fireEvent('openExternalMapsApp', {
                            Address1: $scope.address.Address1,
                            Address2: $scope.address.Address2,
                            City: $scope.address.City,
                            State: $scope.address.State,
                            Zip: $scope.address.Zip,
                            Country: $scope.address.Country
                        });
                        //fire event or whatever is needed to open the external map app with the address
                    };
                }
            };
        }]);